"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeRedirectError = exports.normalizeObjErrorJSError = exports.normalizeObjErrorNetworkError = exports.normalizeObjError = void 0;

var normalizeObjError = function normalizeObjError(req) {
  var objError = {
    'status': req.status,
    'statusText': req.statusText
  };

  try {
    objError.response = JSON.parse(req.response);
  } catch (error) {
    objError.response = req.response;
  }

  return objError;
};

exports.normalizeObjError = normalizeObjError;

var normalizeObjErrorNetworkError = function normalizeObjErrorNetworkError() {
  var objError = {
    'status': 'Network Error',
    'statusText': 'Network Error',
    'response': 'Network Error'
  };
  return objError;
};

exports.normalizeObjErrorNetworkError = normalizeObjErrorNetworkError;

var normalizeObjErrorJSError = function normalizeObjErrorJSError(error) {
  var objError = {
    'status': 'JS Error',
    'statusText': 'JS Error',
    'response': error
  };
  return objError;
};

exports.normalizeObjErrorJSError = normalizeObjErrorJSError;

var normalizeRedirectError = function normalizeRedirectError(req) {
  var urlActual = window.location.href;

  if (window.location.hostname === 'www.movistar.es') {
    // eslint-disable-next-line max-len
    return 'https://www.movistar.es/mimovistar-cliente/publico/servicio/login?urlContenedora=' + req.responseURL + '&urlDestino=' + encodeURIComponent(urlActual);
  } else if (window.location.hostname === 'www.movistar.es.cert') {
    // eslint-disable-next-line max-len
    return 'https://www.movistar.es.cert/mimovistar-cliente/publico/servicio/login?urlContenedora=' + req.responseURL + '&urlDestino=' + encodeURIComponent(urlActual);
  } else if (window.location.hostname === 'www.movistar.es.inte') {
    // eslint-disable-next-line max-len
    return 'https://www.movistar.es.inte/mimovistar-cliente/publico/servicio/login?urlContenedora=' + req.responseURL + '&urlDestino=' + encodeURIComponent(urlActual);
  }

  return '#';
};

exports.normalizeRedirectError = normalizeRedirectError;

//# sourceMappingURL=index.js.map